var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailWhitebk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#FCFCF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5365 17.2337C32.5227 17.1704 32.4924 17.1119 32.4486 17.0642C32.4049 17.0165 32.3492 16.9812 32.2874 16.962C32.0623 16.9176 31.8294 16.9343 31.6129 17.0103C31.6129 17.0103 16.5931 22.4087 15.7354 23.0065C15.5501 23.1351 15.4885 23.2095 15.4579 23.2979C15.3095 23.7233 15.7713 23.9108 15.7713 23.9108L19.6424 25.1724C19.7078 25.1837 19.7749 25.1797 19.8385 25.1606C20.7192 24.6045 28.6986 19.5656 29.1599 19.3963C29.2322 19.3744 29.2858 19.3963 29.274 19.4499C29.0854 20.096 22.1945 26.2197 22.1565 26.2572C22.138 26.2724 22.1235 26.2918 22.1141 26.3138C22.1048 26.3359 22.101 26.3598 22.1029 26.3836L21.7429 30.161C21.7429 30.161 21.5918 31.3395 22.7683 30.161C23.6024 29.3258 24.4027 28.6347 24.804 28.2988C26.1352 29.2176 27.5677 30.2338 28.1854 30.7631C28.289 30.8638 28.4119 30.9425 28.5467 30.9946C28.6814 31.0467 28.8253 31.0711 28.9697 31.0663C29.559 31.0438 29.7197 30.3994 29.7197 30.3994C29.7197 30.3994 32.4561 19.3878 32.5483 17.9119C32.5568 17.7672 32.5692 17.6745 32.5702 17.5754C32.5751 17.4605 32.5638 17.3454 32.5365 17.2337Z",
    fill: "#22252D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.1429,
    height: 17.1429,
    fill: "white",
    transform: "translate(15.4285 15.4287)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailWhitebk);
export default __webpack_public_path__ + "static/media/email_whitebk.b278988c0483c0b5194d061647bf5763.svg";
export { ForwardRef as ReactComponent };